/**
 * Imports
 */
import 'babel-polyfill';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Provider as AlertProvider} from 'react-alert';
import thunkMiddleware from 'redux-thunk';
import AlertTemplate from 'react-alert-template-basic';
import registerServiceWorker from './registerServiceWorker';
import {createStore, applyMiddleware} from 'redux';
import {Provider} from 'react-redux';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {PersistGate} from 'redux-persist/es/integration/react';
import reducers from './reducers';
import {Router, Route, hashHistory} from 'react-router';
import {syncHistoryWithStore, routerMiddleware} from 'react-router-redux';
import Alert from 'react-s-alert';
import jwtDecode from 'jwt-decode';
import {logout} from './actions/users';
import moment from 'moment';
import Config from './config';
import 'react-s-alert/dist/s-alert-default.css';
import './styles/scss/index.scss';

/**
 * Components
 */
import Login from './components/Login';
import UsersGroups from './components/UsersGroups';
import Orders from './components/Orders';
import Stock from './components/Stock';
import Outgoing from './components/Outgoing';
import Search from './components/Search';
import Reports from './components/Reports';

/**
 * Middleware
 */
const middleware = [
    thunkMiddleware,
    routerMiddleware(hashHistory)
];

/**
 * Persist
 */
const persist = persistReducer({
    key: 'root',
    storage: storage,
    blacklist: []
}, reducers);

/**
 * Store configuration
 */
const store = createStore(persist, applyMiddleware(...middleware));

/**
 * Gate
 */
const gate = persistStore(store);

/**
 * History
 */
const history = syncHistoryWithStore(hashHistory, store);

/**
 * Alert options
 */
const options = {
    position: 'bottom center',
    timeout: 5000,
    offset: '30px',
    transition: 'scale'
};

console.log("version 1.0.19");

/**
 * Auth guard
 */
const Auth = (WrappedComponent, userType) => {
    return class WithAuthorization extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                loading: true
            };
        }

        componentWillMount() {
            // if (userType === jwtDecode(localStorage.getItem('apitoken')).Role && this.props.router.location.pathname === '/Search') {
            //   this.setState({
            //     loading: true
            //   }, () => {
            //     this.props.router.push('/')
            //   })
            // }

            if (Config.api.getRole() !== userType && this.props.router.location.pathname === '/UsersGroups') {
              this.setState({
                loading: true
              }, () => {
                this.props.router.push('/')
              })
            }

            if (!store.getState().users.isLoggedIn && this.props.router.location.pathname !== '/login') {

                this.setState({
                    loading: true
                }, () => {
                    this.props.router.push('/login');
                });

            } else {
                const tokenDetails = jwtDecode(Config.api.getToken());

                if (tokenDetails.exp < moment().unix()) {
                    store.dispatch(logout())
                } else {
                    this.setState({
                        loading: false
                    });
                }
            }
        }

        render() {
            const {loading} = this.state;

            if (loading) {
                return null;
            } else {
                return <WrappedComponent {...this.props} />
            }
        }
    }
};

/**
 * Public guard
 */
const Public = (WrappedComponent) => {
    return class WithAuthorization extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                loading: true
            };
        }

        componentWillMount() {
            if (store.getState().users.isLoggedIn && this.props.router.location.pathname === '/login') {
                this.setState({
                    loading: true
                }, () => {
                    this.props.router.push('/');
                });

            } else {
                this.setState({
                    loading: false
                });
            }
        }

        render() {
            const {loading} = this.state;

            if (loading) {
                return null;
            } else {
                return <WrappedComponent {...this.props} />
            }
        }
    }
};

class AppWithStore extends Component{

    constructor(props) {
        super(props);
        this.state = {
            apiEndPoint:null,
        };

        this.getApiSettings();
    }

    getApiSettings(){

        let url = "app.config.json";

        if (!this.state.apiEndPoint){

            if (window.location.hostname==="ecar.demo.awave.se"){
                let headers = new Headers();
                url = "http://ecar.demo.awave.se/app.config.json";
                headers.set('Authorization', 'Basic YXdhdmU6YXdhdmU=');
                fetch(url,{
                    method:'GET',
                    headers:headers
                }).then(response => response.json()).then((data) => {
                    this.setState({
                        apiEndPoint: data.apiEndPoint
                    });
                    window.apiEndPoint = data.apiEndPoint;
                });
            } else {
                fetch(url).then(response => response.json()).then((data) => {
                    this.setState({
                        apiEndPoint: data.apiEndPoint
                    });
                    window.apiEndPoint = data.apiEndPoint;
                });
            }
        } else {
            window.apiEndPoint = this.state.apiEndPoint;
        }
    }

    render(){
        if (!this.state.apiEndPoint){
            return null;
        } else {
            window.apiEndPoint = this.state.apiEndPoint
        }
        return (
            <AlertProvider template={AlertTemplate} {...options}>
                <Provider store={store}>
                    <PersistGate persistor={gate}>
                        <Router history={history}>
                            <Route
                                path="/"
                                component={Auth(Orders)}
                            />
                            <Route
                                path="/login"
                                component={Public(Login)}
                            />
                            <Route
                                path="/UsersGroups"
                                component={Auth(UsersGroups, 'Administrator')}
                            />
                            <Route
                                path="/Orders"
                                component={Auth(Orders)}
                            />
                            <Route
                                path="/Stock"
                                component={Auth(Stock)}
                            />
                            <Route
                                path="/Outgoing"
                                component={Auth(Outgoing)}
                            />
                            <Route
                                path="/Search"
                                component={Auth(Search, 'Administrator')}
                            />
                            <Route
                                path="/Reports"
                                component={Auth(Reports, 'Administrator')}
                            />
                        </Router>
                    </PersistGate>
                </Provider>

                <Alert
                    stack={{limit: 1}}
                    position={'top-right'}
                    effect={"slide"}
                    timeout={5000}
                />

            </AlertProvider>
        );
    }
}

ReactDOM.render(<AppWithStore/>, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js